import api from '@/services/api';

const UserSettingsUpdate = {
  updateUserDialogSettings: userDialogSettings => {
    return api.post('update_user_dialog_settings/', userDialogSettings);
  }
};

export default UserSettingsUpdate;



// WEBPACK FOOTER //
// ./src/api/account/user_settings/update.js